import React from 'react'
import { DiGit } from 'react-icons/di';
import { DiJavascript1 } from 'react-icons/di';
import { DiJava } from 'react-icons/di';
import { DiReact } from 'react-icons/di';
import { FaLaravel } from 'react-icons/fa';
import profile from '../img/profile.jpg';

const Profile = () => {
    return (
        <section className='text-white bg-color-dark grid grid-cols-1 lg:grid-cols-12 md:text-wrap justify-center items-center md:justify-start py-8 md:py-0 h-screen'>

            <article className='lg:col-start-2 lg:col-end-6 text-center flex justify-center'>
                <img className='w-72 lg:w-4/5 2xl:w-8/12 rounded-xl' src={profile} alt="myimage" />
            </article>

            <article className='lg:col-start-6 lg:col-end-13 xl:col-start-6 flex flex-col lg:justify-start align-top gap-4 m-2'>

                <p className='text-base md:text-lg flex justify-center lg:justify-start'>
                    <span className='text-red-600 pe-2 hidden sm:block'>{'<span>'}</span>
                    <span>Hi, I'm Vicenzo!</span>
                    <span className='text-red-600 ps-2 hidden sm:block'>{'</span>'}</span>
                </p>

                <h2 className='text-white text-xl md:text-2xl lg:text-3xl 2xl:text-4xl flex justify-center gap-1 lg:justify-start'>
                    <p className='text-red-600  hidden sm:block '>{'<h1>'}</p>
                    <p>Junior</p>   
                    <span className='text-green-900'>
                        {'{Full Stack}'}
                    </span>
                    <p>Developer</p>
                    <p className='text-red-600  hidden sm:block '>{'<h1>'}</p>
                </h2>

                <div className='text-gray-400 text-md lg:text-lg 2xl:text-xl flex flex-wrap justify-center lg:justify-start gap-2'>

                    <span className="text-center lg:text-start flex flex-wrap md:gap-2 w-[80%]">
                        <p className='text-red-600 pe-2 hidden lg:block max-w-9'>{'<p>'}</p>
                        <p>
                            Expertise in technologies such as
                            React, SQL, Laravel, Java, Javascript
                            and
                            Tailwind.
                            I deliver both innovative and robust web solutions.
                        </p>
                        <p className='text-red-600 pe-2 hidden lg:block max-w-9'>{'</p>'}</p>
                    </span>



                </div>

                {/* <p className='flex flex-wrap justify-center items-baseline text-3xl hidden'>

                    <span className='flex flex-wrap items-center gap-2'>
                        <DiReact />
                        <DiJava />
                        <FaLaravel />
                        <DiJavascript1 />
                        <DiGit />
                    </span>

                    <span className='text-gray-400 hidden text-base sm:block'>
                        ... and more
                    </span>

                </p> */}

            </article>
        </section>
    )
}

export default Profile